import { useVertical } from "./useVertical";

/**
 * Industry relabeling. Grocery is the untouched default template, so for grocery
 * the `nav()` transform is identity. Other verticals re-skin nav / page labels
 * from their terminology map (Categories→Departments, Stores→Facilities, etc).
 */
export function useLabels() {
  const { id, terms } = useVertical();
  const grocery = id === "grocery";

  const nav = (label: string): string => {
    if (grocery) return label;
    const map: Record<string, string> = {
      "Categories": terms.categories,
      "Stores": terms.stores,
      "Store Clusters": `${terms.store} Clusters`,
      "Store Clustering": `${terms.store} Clustering`,
      "Shelf Optimization": `${terms.shelf} Optimization`,
      "AI Assortment": `AI ${terms.assortment}`,
      "AI Assortment Engine": `AI ${terms.assortment} Engine`,
      "Assortment overview": `${terms.assortment} overview`,
    };
    return map[label] || label;
  };

  return { id, terms, grocery, nav };
}
